module.exports = __webpack_public_path__ + "static/img/profile-icon03.ea48f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/profile-icon03.png
// module id = 2951
// module chunks = 1